import { AppBar, Dialog, IconButton, Paper, Slide, Toolbar } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getOpenAdvancedSearchDialog, handleOpenAdvancedSearchDialog } from "../../../reducers/uiSlice";
import AdvancedSearch from "../../AdvancedSearch";
import CloseIcon from '@material-ui/icons/Close';
import { forwardRef } from "react";

function AdvancedSearchModal(props){
    const {t} = useTranslation('advancedSearch')
    const dispatch = useDispatch();
    let openAdvancedSearchDialog = useSelector(getOpenAdvancedSearchDialog);

    return (
        <Dialog
            title={t('advanced_search')}
            fullScreen
            open={openAdvancedSearchDialog}
            onClose={() => 
                dispatch(handleOpenAdvancedSearchDialog(false))
            }
        >
            <AppBar style={{position: 'relative'}}>
                <Toolbar style={{textAlign: 'right'}}>
                    <div style={{width: '100%'}}>
                        <IconButton 
                            edge="start"
                            onClick={() => 
                                dispatch(handleOpenAdvancedSearchDialog(false))
                            } 
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
            <Paper style={{marginTop: 30}}>
                <AdvancedSearch open={openAdvancedSearchDialog}/>
            </Paper>
        </Dialog>
    )
}

export default AdvancedSearchModal